import {
  WALLET_TRANSACTION_HISTORY,
  WALLET_TRANSACTION_HISTORY_SUCCESS,
  CLEAN_WALLET_TRANSACTION_HISTORY,
  KYC_DONE,
  KYC_DONE_SUCCESS,
  GET_EXPENSE_IMAGE,
  GET_EXPENSE_IMAGE_SUCCESS,
  DELETE_EXPENSE,
  DELETE_EXPENSE_SUCCESS,
  EDIT_EXPENSE_SUCCESS,
  EDIT_EXPENSE,
  QR_CODE,
  QR_CODE_SUCCESS,
  BULK_TRANSFER_SAMPLE,
  BULK_TRANSFER_SAMPLE_SUCCESS,
  BULK_TRANSFER_UPLOAD_SUCCESS,
  BULK_TRANSFER_UPLOAD,
  BULK_ADD_DRIVER_UPLOAD,
BULK_ADD_DRIVER_UPLOAD_SUCCESS,
CHANGE_DRIVER_LIMIT,
CHANGE_DRIVER_LIMIT_SUCCESS,
MODIFY_LIMIT,
MODIFY_LIMIT_SUCCESS,
VERIFY_OTP_FOR_LIMIT,
VERIFY_OTP_FOR_LIMIT_SUCCESS,
REGISTOR_NEW_CUSTOMER,
REGISTOR_NEW_CUSTOMER_SUCCESS,
REGISTOR_NEW_CUSTOMER_VERIFY_OTP,
REGISTOR_NEW_CUSTOMER_VERIFY_OTP_SUCCESS,
CUSTOMER_MIN_KYC,
CUSTOMER_MIN_KYC_SUCCESS,
REPLACE_CARD,
REPLACE_CARD_SUCCESS,
BLOCK_CARD,
BLOCK_CARD_SUCCESS,
BULK_WITHDRAWL_UPLOAD,
BULK_WITHDRAWL_UPLOAD_SUCCESS,
BULK_ADD_DRIVER_COMPLETE_UPLOAD,
BULK_ADD_DRIVER_COMPLETE_UPLOAD_SUCCESS,
  GET_TRANSACTION_DETAILS,
  GET_TRANSACTION_DETAILS_SUCCESS,
  GET_TRANSACTION_SLIP_PDF,
  GET_TRANSACTION_SLIP_PDF_SUCCESS,
  GET_CARD_TRANSACTION_DETAILS,
  GET_CARD_TRANSACTION_DETAILS_SUCCESS,
  GET_FASTAG_TRANSACTION_DETAILS,
  GET_FASTAG_TRANSACTION_DETAILS_SUCCESS,
  GET_FASTAG_WALLET_TRANSACTION_DETAILS,
  GET_FASTAG_WALLET_TRANSACTION_DETAILS_SUCCESS,
  CLEAR_TRANSACTION_DETAILS,
  GET_CARD_TRANSACTION_SLIP_PDF,
  GET_CARD_TRANSACTION_SLIP_PDF_SUCCESS,
  GET_FASTAG_TRANSACTION_SLIP_PDF,
  GET_FASTAG_TRANSACTION_SLIP_PDF_SUCCESS,
  GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF,
  GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF_SUCCESS,  
  SAVE_SLIP,
  SAVE_SLIP_SUCCESS,
  GET_CARD_WALLET_BALANCE,
  GET_CARD_WALLET_BALANCE_SUCCESS,
  GET_CARD_WALLET_HISTORY,
  GET_CARD_WALLET_HISTORY_SUCCESS,
  CLEAR_CARD_WALLET_HISTORY,
  CREATE_CARD_WALLET,
  CREATE_CARD_WALLET_SUCCESS,
  GENERATE_CARD_WALLET_STATEMENT,
  GENERATE_CARD_WALLET_STATEMENT_SUCCESS,
  GET_CARD_WALLET_TXNSLIP,
  GET_CARD_WALLET_TXNSLIP_SUCCESS,
  DOWNLOAD_CARD_WALLET_TXNSLIP_PDF,
  DOWNLOAD_CARD_WALLET_TXNSLIP_PDF_SUCCESS,

} from "../storeTypes";



export const qrcodeAction = (data) => {
  console.log("step-a");
  return {
    type: QR_CODE,
    payload: data,
  };
};
export const qrcodeActionSuccess = (payload) => {
  return {
    type: QR_CODE_SUCCESS,
    payload,
  };
};

export const bulkTransferSampleSuccess = (payload) => {
  return {
    type: BULK_TRANSFER_SAMPLE_SUCCESS,
    payload,
  };
};

export const bulkTransferUpload = (payload,callback) => {
  return {
    type: BULK_TRANSFER_UPLOAD,
    payload,
    callback
  };
};
export const bulkTransferUploadSuccess = (payload) => {
  return {
    type: BULK_TRANSFER_UPLOAD_SUCCESS,
    payload,
  };
};

export const bulkAddDriverUpload = (payload,callback) => {
  return {
    type: BULK_ADD_DRIVER_UPLOAD,
    payload,
    callback
  };
};
export const bulkAddDriverUploadSuccess = (payload) => {
  return {
    type: BULK_ADD_DRIVER_UPLOAD_SUCCESS,
    payload,
  };
};

export const getWalletTransactionHistory = (data) => {
  console.log("step-a");
  return {
    type: WALLET_TRANSACTION_HISTORY,
    payload: data,
  };
};
export const getWalletTransactionHistorySuccess = (payload) => {
  return {
    type: WALLET_TRANSACTION_HISTORY_SUCCESS,
    payload,
  };
};
export const cleanWalletTransactionHistory = () => {
  return {
    type: CLEAN_WALLET_TRANSACTION_HISTORY,
  };
};

export const kycDoneAction = (obj, callback) => {
  return {
    type: KYC_DONE,
    payload: obj,
    callback,
  };
};
export const kycDoneActionSuccess = (data) => {
  console.log("step-a")
  return {
    type: KYC_DONE_SUCCESS,
    payload: data,
  };
};

export const getExpenseImageAction = (typeExp, id, callback) => {
  //console.log("step-a")
  return {
    type: GET_EXPENSE_IMAGE,
    typeExp: typeExp,
    id: id,
    callback,
  };
};
export const getExpenseImageSuccessAction = (payload) => {
  return {
    type: GET_EXPENSE_IMAGE_SUCCESS,
    payload,
  };
};

export function deleteExpenseAction(id) {
  return {
    type: DELETE_EXPENSE,
    payload: id,
  };
}
export function deleteExpenseActionSuccess(data) {
  return {
    type: DELETE_EXPENSE_SUCCESS,
    payload: data,
  };
  
}

export function editExpenseAction(id, data) {
  return {
    type: EDIT_EXPENSE,
    id:id,
    payload:data,
  };
}
export function editExpenseActionSuccess(data) {
  return {
    type: EDIT_EXPENSE_SUCCESS,
    payload: data,
  };  
}

export function downloadBulkTransferAction(data,callback) {
  return {
    type: BULK_TRANSFER_SAMPLE,
    payload: data,
    callback
  };  
}

export function changeDriverLimit(data,callback) {
  return {
    type: CHANGE_DRIVER_LIMIT,
    payload:data,
    callback
  };
}
export function changeDriverLimitSuccess(data) {
  return {
    type: CHANGE_DRIVER_LIMIT_SUCCESS,
    payload: data,
  };  
}

export const modifyLimitAction = (payload, callBack) => {
  return {
    type: MODIFY_LIMIT,
    payload: payload,
    callBack,
  };
};
export const modifyLimitSuccess = payload => {
  return {
    type: MODIFY_LIMIT_SUCCESS,
    payload: payload,
  };
};
export const verifyOtpForLimit = (payload, callBack) => {
  return {
    type: VERIFY_OTP_FOR_LIMIT,
    payload: payload,
    callBack,
  };
};
export const verifyOtpForLimitSuccess = payload => {
  return {
    type: VERIFY_OTP_FOR_LIMIT_SUCCESS,
    payload: payload,
  };
};


export const registorNewCustomer = (payload, callBack) => {
  return {
    type: REGISTOR_NEW_CUSTOMER,
    payload: payload,
    callBack,
  };
};
export const registorNewCustomerSuccess = payload => {
  return {
    type: REGISTOR_NEW_CUSTOMER_SUCCESS,
    payload: payload,
  };
};

export const registorNewCustomerVerifyOtp = (payload, callBack) => {
  return {
    type: REGISTOR_NEW_CUSTOMER_VERIFY_OTP,
    payload: payload,
    callBack,
  };
};
export const registorNewCustomerVerifyOtpSuccess = payload => {
  return {
    type: REGISTOR_NEW_CUSTOMER_VERIFY_OTP_SUCCESS,
    payload: payload,
  };
};

export const customerMiniKyc = (payload, callBack) => {
  return {
    type: CUSTOMER_MIN_KYC,
    payload: payload,
    callBack,
  };
};
export const customerMiniKycSuccess = payload => {
  return {
    type: CUSTOMER_MIN_KYC_SUCCESS,
    payload: payload,
  };
};

export const replaceCard = (payload, callBack) => {
  return {
    type: REPLACE_CARD,
    payload: payload,
    callBack,
  };
};
export const replaceCardSuccess = payload => {
  return {
    type: REPLACE_CARD_SUCCESS,
    payload: payload,
  };
};
export const blockCard = (payload, callBack) => {
  return {
    type: BLOCK_CARD,
    payload: payload,
    callBack,
  };
};
export const blockCardSuccess = payload => {
  return {
    type: BLOCK_CARD_SUCCESS,
    payload: payload,
  };
};

export const bulkWithdrawlUpload = (payload,callback) => {
  return {
    type: BULK_WITHDRAWL_UPLOAD,
    payload,
    callback
  };
};
export const bulkWithdrawlUploadSuccess = (payload) => {
  return {
    type: BULK_WITHDRAWL_UPLOAD_SUCCESS,
    payload,
  };
};

export const bulkAddDriverCompleteUpload = (payload,callback) => {
  return {
    type: BULK_ADD_DRIVER_COMPLETE_UPLOAD,
    payload,
    callback
  };
};
export const bulkAddDriverCompleteUploadSuccess = (payload) => {
  return {
    type: BULK_ADD_DRIVER_COMPLETE_UPLOAD_SUCCESS,
    payload,
  };
};


export const getTransactionDetails = payload => {
  return {
    type: GET_TRANSACTION_DETAILS,
    payload,
  };
};

export const getTransactionDetailsSuccess = payload => {
  return {
    type: GET_TRANSACTION_DETAILS_SUCCESS,
    payload,
  };
};
export const getCardTransactionDetails = (payload, callBack) => {
  return {
    type: GET_CARD_TRANSACTION_DETAILS,
    payload,
    callBack,
  };
};
export const getCardTransactionDetailsSuccess = payload => {
  return {
    type: GET_CARD_TRANSACTION_DETAILS_SUCCESS,
    payload,
  };
};
export const getFastagTransactionDetails = payload => {
  return {
    type: GET_FASTAG_TRANSACTION_DETAILS,
    payload,
  };
};
export const getFastagTransactionDetailsSuccess = payload => {
  return {
    type: GET_FASTAG_TRANSACTION_DETAILS_SUCCESS,
    payload,
  };
};
export const getFastagWalletTransactionDetails = payload => {
  return {
    type: GET_FASTAG_WALLET_TRANSACTION_DETAILS,
    payload,
  };
};
export const getFastagWalletTransactionDetailsSuccess = payload => {
  return {
    type: GET_FASTAG_WALLET_TRANSACTION_DETAILS_SUCCESS,
    payload,
  };
};
export const clearTransactionDetails = () => {
  return {
    type: CLEAR_TRANSACTION_DETAILS,
  };
};
export const getCardTransactionSlipPdf = (payload, callBack) => {
  return {
    type: GET_CARD_TRANSACTION_SLIP_PDF,
    payload,
    callBack,
  };
};
export const getCardTransactionSlipPdfSuccess = payload => {
  return {
    type: GET_CARD_TRANSACTION_SLIP_PDF_SUCCESS,
    payload,
  };
};
export const getFastagTransactionSlipPdf = (payload, callBack) => {
  return {
    type: GET_FASTAG_TRANSACTION_SLIP_PDF,
    payload,
    callBack,
  };
};
export const getFastagTransactionSlipPdfSuccess = payload => {
  return {
    type: GET_FASTAG_TRANSACTION_SLIP_PDF_SUCCESS,
    payload,
  };
};
export const getFastagWalletTransactionSlipPdf = (payload, callBack) => {
  return {
    type: GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF,
    payload,
    callBack,
  };
};
export const getFastagWalletTransactionSlipPdfSuccess = payload => {
  return {
    type: GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF_SUCCESS,
    payload,
  };
};
export const getTransactionSlipPdf = (payload, callBack) => {
  return {
    type: GET_TRANSACTION_SLIP_PDF,
    payload,
    callBack,
  };
};
export const getTransactionSlipPdfSuccess = payload => {
  return {
    type: GET_TRANSACTION_SLIP_PDF_SUCCESS,
    payload,
  };
};

export const saveSlipAction = (payload, callback) => {
  console.log('hetrere', payload, callback);
  return {
    type: SAVE_SLIP,
    payload,
    callback,
  };
};
export const saveSlipActionSuccess = () => {
  return {
    type: SAVE_SLIP_SUCCESS,
  };
};

export const getCardWalletBalance = (payload, callback) => {
  console.log('hetrere', payload, callback);
  return {
    type: GET_CARD_WALLET_BALANCE,
    payload,
    callback,
  };
};
export const getCardWalletBalanceSuccess = (data) => {
  return {
    type: GET_CARD_WALLET_BALANCE_SUCCESS,
    payload: data,
  };
};

export const getCardWalletHistory = (payload, callback) => {
  console.log('hetrere', payload, callback);
  return {
    type: GET_CARD_WALLET_HISTORY,
    payload,
    callback,
  };
};
export const getCardWalletHistorySuccess = (data) => {
  return {
    type: GET_CARD_WALLET_HISTORY_SUCCESS,
    payload: data,
  };
};
export const clearCardWalletHistory = () => {
  return {
    type: CLEAR_CARD_WALLET_HISTORY,
  };
};

export const createCardWallet = (payload, callback) => {
  console.log('hetrere', payload, callback);
  return {
    type: CREATE_CARD_WALLET,
    payload,
    callback,
  };
};
export const createCardWalletSuccess = (data) => {
  return {
    type: CREATE_CARD_WALLET_SUCCESS,
    payload: data,
  };
};

export function getCardWalletStatement(data,callback) {
  console.log("fatagw", data);
  return {
    type: GENERATE_CARD_WALLET_STATEMENT,
    payload: data,
    callback
  };
}
export function getCardWalletStatementSuccess(data) {
  return {
    type: GENERATE_CARD_WALLET_STATEMENT_SUCCESS,
    payload: data,
  };
}

export function getCardWalletTxnSlip(data,callback) {
  console.log("fatagw", data);
  return {
    type: GET_CARD_WALLET_TXNSLIP,
    payload: data,
    callback
  };
}
export function getCardWalletTxnSlipSuccess(data) {
  return {
    type: GET_CARD_WALLET_TXNSLIP_SUCCESS,
    payload: data,
  };
}

export function downloadCardWalletTxnSlipPdf(data,callback) {
  console.log("fatagw", data);
  return {
    type: DOWNLOAD_CARD_WALLET_TXNSLIP_PDF,
    payload: data,
    callback
  };
}
export function downloadCardWalletTxnSlipPdfSuccess(data) {
  return {
    type: DOWNLOAD_CARD_WALLET_TXNSLIP_PDF_SUCCESS,
    payload: data,
  };
}
